import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { Icon, Spinner } from 'ui';
import { routes } from 'constants/config';

import { getQueryParam } from 'utils/url';
import useFetch from 'components/shared/hooks/useFetch';
import ModuleLoadFailure from './ModuleLoadFailure';

const thumbsUpIcon = locale => {
  if (locale === 'ar') return 'saved';
  return 'thumbs_up';
};

const thumbsDownIcon = locale => {
  if (locale === 'ar') return 'remove';
  return 'thumbs_down';
};

const LearnerRatings = ({ match }) => {
  const { lessonId } = match.params;
  const { locale } = window.I18n;
  const currentGroupId = getQueryParam(window.location.href, 'group_id');
  const { data, loading, error, runRequest } = useFetch(
    routes.LESSON_OVERVIEW.RATINGS(lessonId, currentGroupId),
  );
  if (loading) return <Spinner />;
  if (error) {
    return <ModuleLoadFailure reload={runRequest} />;
  }
  const {
    totalRatings,
    numberLiked,
    numberDisliked,
    percentLiked,
    percentDisliked,
    canViewRatings,
  } = data.ratings;
  const iconForType = (type, count) => {
    const iconTag =
      type === 'liked' ? (
        <>
          <Icon name={thumbsUpIcon(locale)} />
          {count}
        </>
      ) : (
        <>
          {count}
          <Icon name={thumbsDownIcon(locale)} />
        </>
      );
    const className = type === 'liked' ? 'likes' : 'dislikes';
    const route =
      type === 'liked'
        ? routes.LESSON_OVERVIEW.RATINGS_LIKED(lessonId)
        : routes.LESSON_OVERVIEW.RATINGS_DISLIKED(lessonId);
    if (canViewRatings && count > 0) {
      return (
        <a href={route} className={`LearnerReviews-${className} decorated`}>
          {iconTag}
        </a>
      );
    }
    return <span className={`LearnerReviews-${className}`}>{iconTag}</span>;
  };
  return (
    <section className="Module EditableModule ml-24 w-180">
      <h3 className="Module-heading SectionHeading">
        {t('lessons.learner_ratings.title')}
      </h3>
      {totalRatings === 0 && (
        <p className="Placeholder u-sans">
          {t('lessons.learner_ratings.no_ratings')}
        </p>
      )}
      {totalRatings > 0 && (
        <div className="LearnerReviews">
          <div className="LearnerReviews-ratioBar">
            <div
              className="LearnerReviews-ratio LearnerReviews-ratio--positive"
              data-toggle="tooltip"
              data-original-title={percentLiked}
              style={{ width: percentLiked }}
            />
            <div
              className="LearnerReviews-ratio LearnerReviews-ratio--negative"
              data-toggle="tooltip"
              data-original-title={percentDisliked}
              style={{ width: percentDisliked }}
            />
          </div>
          <div className="LearnerReviews-counts">
            {iconForType('liked', numberLiked)}
            {iconForType('disliked', numberDisliked)}
          </div>
        </div>
      )}
    </section>
  );
};

const LearnerRatingsRoot = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/lessons/:lessonId" component={LearnerRatings} />
      </Switch>
    </BrowserRouter>
  );
};
export default props => <LearnerRatingsRoot {...props} />;
